module.exports = __webpack_public_path__ + "media/images/emblems/Kestenholz-blason-d28f6ef4dc1f5168bd7880cc075e0da0.png";